
define('template!sdcAlerts',[''],function(template){return '<div class="alert alert-dismissable" role="alert">\r\n\t<button type="button"class="close" aria-label="Close"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button>\r\n\t<strong ng-bind="alert."></strong>\r\n</div> ';});

